<template>
    <v-container fluid>
    
        <v-card flat>
            <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                <v-icon>new_releases</v-icon>
                <v-toolbar-title class="font-weight-light">Alta de Consultas</v-toolbar-title>
                <v-spacer></v-spacer>
                
                <!-- <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">                        
                <v-icon  medium>add_circle_outline</v-icon>
                </v-btn> -->
                
                <v-btn v-if="model.id != null" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                <v-icon v-if="editMode">cancel</v-icon>
                <v-icon v-else>edit</v-icon>
                </v-btn>
            </v-app-bar>
            <v-card-text>
                <v-container fluid>
                    <v-row >
                      
                          <v-row align="center" dense>
                        <v-col cols="12">
                            <v-text-field label="Documento" v-model="model.documento" append-icon="search" 
                            @click:append="buscarPersonaPorDocumento(model.documento)"
                            v-validate="'required'" data-vv-name="documento"></v-text-field>
                            </v-col>
                          </v-row>
                        <v-col cols="6">
                            <v-autocomplete v-model="model.sectorOrigenId" :items="listSectorOrigen" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Sector de Origen" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="model.nombre" label="Nombre" required :disabled="!editMode" 
                            v-validate="'required'" data-vv-name="nombre" :error-messages="errors.collect('nombre')"></v-text-field>
                        </v-col>
                         <v-col cols="6">        
                            <v-autocomplete v-model="model.resultadoId" :items="listResultado" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Resultado" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row v-if="validacionGeografica" align="center" dense>
                        <v-col cols="5">
                            <v-text-field v-model="telefonoEditor.numero" label="Teléfono" v-validate="'required'" data-vv-name="numero" counter >
                                <template v-slot:append v-if="!telefonoEditor.telefonoValidado && !validando">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" @click="validarTelefono">help_outline</v-icon>
                                        </template>
                                        <span>Ingresar los 10 números del teléfono (sin el 15  ni el '0' delante del código de área) y presione para validar</span>
                                    </v-tooltip>
                                </template>
                            </v-text-field>                            
                        </v-col>
                      
                        <v-col cols="1">
                            <v-icon v-if="telefonoEditor.telefonoValidado" color="green">check_circle_outline</v-icon>
                            <v-icon v-else-if="validando" color="grey">update</v-icon>
                        </v-col>
                        <v-col  v-if="resultadoValidacion.esValido == false && resultadoValidacion.motivoNoValida">
                            <v-chip  class="caption" color="red" dark>{{resultadoValidacion.motivoNoValida}}</v-chip>
                        </v-col>
                         
                        <v-col cols="6">
                            <v-text-field v-model="model.email" label="Email" :disabled="!editMode"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col cols="6">        
                            <v-autocomplete v-model="model.tipoClienteId" :items="listTipoCliente" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Tipo Cliente" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>
                        <v-col cols="6">        
                            <v-autocomplete v-model="model.canalConsultaId" :items="listCanalConsulta" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Canal Consulta" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>

                    </v-row>

                    <v-row>
                       <v-col cols="6">
                            <v-autocomplete v-model="model.motivoConsultaId" :items="listMotivoConsulta" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Motivo Consulta" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>

                        <v-col cols="6">        
                            <v-autocomplete v-model="model.respuestaMotorId" :items="listRespuestaMotor" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Respuesta Motor" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                       <v-col cols="6">        
                            <v-autocomplete v-model="model.motivoRechazoId" :items="listMotivoRechazo" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Motivo Rechazo" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>
                         
                         <v-col cols="6">        
                            <v-autocomplete v-model="model.canalDerivadoId" :items="listCanalDerivado" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Canal Derivado" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>
                                    
                    </v-row>     

                    <v-row>
                       <v-col cols="6">        
                            <v-autocomplete v-model="model.bancoId" :items="listBancos" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Bancos" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>
                         
                         <v-col cols="6">        
                            <v-autocomplete v-model="model.situacionLaboralActividadId" :items="listSituacionLaboralActividad" :disabled="!editMode"
                            item-text="descripcion" item-value="id" label="Situacion Laboral" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>
                                    
                    </v-row>   
                        <v-textarea v-model="model.comentarios" 
                            class="mx-2"
                            label="Comentarios"
                            prepend-icon="comment"
                            clearable
                            auto-grow 
                            :disabled="!editMode">
                        </v-textarea>
                         
                    
                </v-container>
            </v-card-text>

            <v-divider></v-divider>  
            <v-card-actions>
                <v-btn color="blue darken-1" text @click.stop="hide(false)" >Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click.stop="guardar" :disabled="!editMode">Guardar</v-btn>
            </v-card-actions>
        </v-card>
         <template v-if="$store.state.debugModeOn">
                        Debug Info: <p></p>
                        
                        Editor: {{telefonoEditor}}  <p></p>
                        Validacion: {{resultadoValidacion}}  <p></p>
            </template>
        
        <template v-if="$store.state.debugModeOn">
            Debug Info: <p></p>
            
            Model: {{model}}  <p></p>                            
        </template>
    </v-container>
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'
import { format } from 'date-fns'

import {
  mapGetters,
  mapMutations,
} from 'vuex'

export default {
    data: () => ({
            model:{id:'',fecha: format(new Date(),'YYYY-MM-DD'),nombre: '', documento: '',tipoClienteId: 0,canalConsultaId:0,motivoConsultaId:0,responsableCarga:'',
            sectorOrigenId : 0,resultadoId : 0,bancoId:0,situacionLaboralActividadId : 0, personaId :'',
            respuestaMotorId:0,motivoRechazoId:0,canalDerivadoId:0,comentarios : '',telefono: '',email:'',},
            telefonoEditor: {numero:'',perteneceA:{},estaVerificado:false, codigoVerificacionTemporal:""},
            created: false,
            selectedPersonaBusqueda: null,
            loading: false,
            infoResumida: null,
            listTipoCliente:[],
            listCanalConsulta:[],
            listMotivoConsulta:[],
            infoCrediticia: null,
            listRespuestaMotor:[],
            listMotivoRechazo:[],
            listCanalDerivado:[],
            listSectorOrigen:[],
            listResultado:[],
            listSituacionLaboralActividad:[],
            listBancos:[],
            ingresoPor: 'documento',
            
            editMode: false,
            validando:false,
            resultadoValidacion: {esValido: true},
        }
    ),
    props:{
        editModeProp: { type:Boolean, default: false },
        consultaId: { type: String },      
        isSubTask: { type: Boolean, default: false },
        visible: { type: Boolean,default: false },
        editConsulta: { type: Object, default: null },
    },

    async created(){
        Vue.$log.debug(this.editModeProp);
        this.editMode = this.editModeProp;
        
        this.validacionGeografica = this.$store.state.parametrosGenerales.validacionGeograficaTelefono;
        
        await this.loadTipoCliente();
        await this.loadCanalConsulta();
        await this.loadMotivoConsulta();
        await this.loadRespuestaMotor();
        await this.loadSituacionLaboralActividad();
        await this.loadMotivoRechazo();
        await this.loadCanalDerivado();
        await this.loadSectorOrigen();
        await this.loadResultado();
        await this.loadBanco();
        this.ingresoPor = this.$store.state.parametrosGenerales.ingresoPorDefectoPor;

        if(this.consultaId){
            await this.loadConsulta(this.consultaId);
        }
    },
    computed: {
        ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete', 'getActionFromLink','user']),
        canCreate: function(){
            return this.checkCanCreate(this.$route.path)
        },
        canUpdate: function(){
            return this.checkCanUpdate(this.$route.path)
        },
        canDelete: function(){
            return this.checkCanDelete(this.$route.path)
        },
        action: function(){
            return this.getActionFromLink(this.$route.path)
        }
    },
    watch:{
        'telefonoEditor.numero': function(){   
            Vue.$log.debug('telefonoEditor.numero changed')
            if(!this.resultadoValidacion.esValido)
            {
                this.telefonoEditor.telefonoValidado = false;
            }

            this.resultadoValidacion.esValido = false;
        },
    },
    
    methods:{
    ...mapMutations(["setActiveTask", "setActiveSubTask", "hideActiveTask", "hideActiveSubTask", 
                        "alertClear", "alertSuccess", "alertWarning", "alertError"]),
    async guardar(){
        
        if(!this.validarIngreso()) return;

        await this.$validator.validateAll()
        
        if(this.errors.items.length > 0){            
            return;
        } 
         
        if(this.validacionGeografica && !this.telefonoEditor.telefonoValidado)
        {
            this.alertWarning("Por favor, valide el teléfono antes de confirmar.")
            return;
        }

        this.loading = true;
        let isUpdate = this.model.id != "00000000-0000-0000-0000-000000000000"

        this.model.telefono = this. telefonoEditor.numero;
        
        try {
            if(isUpdate)
                await http.put('manejoconsulta', JSON.stringify( {consultas:  this.model} ) );
            else
            {
                this.model.responsableCarga = this.user.login;
                await http.post('manejoconsulta', JSON.stringify( {consultas:  this.model} ) );
            }

            this.alertSuccess('Se ha guardado la información de la consulta.')

            this.hide(true);
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false  ;
    },
    
   async validarTelefono(){
        if(!this.telefonoEditor.numero)
        {
            this.alertWarning("Debe ingresar el número de teléfono a validar.")
            return;
        }

        this.validando = true

        try {
            var result = await http.get('BusinessCore/validartelefonobasegeografica'
                + '?telefono='+ this.telefonoEditor.numero);

            if(result.esValido)
            {
                this.telefonoEditor.numero = result.numeroFormateado;
            }

            this.telefonoEditor.esValido = result.esValido;
            this.telefonoEditor.telediscado = result.numeroPuro;
            this.telefonoEditor.telefonoValidado = result.esValido;
            this.telefonoEditor.esCelular = !result.esFijo;

            this.resultadoValidacion = result;
        } catch (error) {
            // Error
            this.alertError(error)
            Vue.$log.error(error);
        }
        this.validando = false
      },

    async loadConsulta(){
        this.loading = true
        try {
            var result = await http.get('manejoconsulta/'  +this.consultaId  );
            this.model = result;
            
            this.telefonoEditor.numero = this.model.telefono;            
            this.telefonoEditor.telefonoValidado = true;
            this.telefonoEditor.numero = this.model.telefono;

            this.ingresoPor = 'documento';
            
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async editItem(){
        this.editMode = true;
    },
    async loadTipoCliente(){
        this.loading = true;
        try{
            var result = await http.get('tiposcliente');
            this.listTipoCliente = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadCanalConsulta(){
        this.loading = true;
        try{
            var result = await http.get('tiposcanalconsulta');
            this.listCanalConsulta = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadSectorOrigen(){
        this.loading = true;
        try{
            var result = await http.get('tipossectororigen');
            this.listSectorOrigen = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadResultado(){
        this.loading = true;
        try{
            var result = await http.get('tiposresultado');
            this.listResultado = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadMotivoConsulta(){
        this.loading = true;
        try{
            var result = await http.get('tiposmotivoconsulta');
            this.listMotivoConsulta = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadRespuestaMotor(){
        this.loading = true;
        try{
            var result = await http.get('tiposrespuestamotor');
            this.listRespuestaMotor = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadMotivoRechazo(){
        this.loading = true
        try {
            var result = await http.get('tiposmotivorechazo'); 
            this.listMotivoRechazo = result.list;
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    }, 
    async loadCanalDerivado(){
        this.loading = true
        try {
            var result = await http.get('tiposcanalventaderivado'); 
            this.listCanalDerivado = result.list;
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
     async loadSituacionLaboralActividad(){
          this.loading = true
        try {
            var result = await http.get('situacioneslaborales/actividades'); // traigo todas
            this.listSituacionLaboralActividad = result.list;
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async loadBanco(){
        this.loading = true
        try {
            var result = await http.get('entidadesfinancieras'); // traigo todas
            this.listBancos = result.list;
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    validarIngreso(){
        let isUpdate = this.model.id != "00000000-0000-0000-0000-000000000000"
        if(isNaN(parseInt(this.model.documento)) || this.model.documento.length >8)
        {
            this.alertWarning('Verifique el documento ingresado.');
            return false;
        }

        if(!this.model.sectorOrigenId || this.model.sectorOrigenId == 0)
        {
            this.alertWarning('Por favor, seleccione el Sector de Origen.');
            return false;
        }

        if(!isUpdate && !this.telefonoEditor.esCelular){
            this.alertWarning('Sólo se permite el ingreso de un teléfono celular.  Por favor, verifique el ingresado.');
            return false;
        }
        return true;
    },  
    async buscarPersonaPorDocumento(documento){

      this.loading = true

      try {
          var result = await http.get('personas/listapordocumento?documento='+ documento);
          //traigo el resultado de la persona.
          if(result.count >= 1)
          {
            this.setPersonaBusqueda(result.list[0])
          }
          else{
            this.model.nombre = ""
            this.model.email = ""
            this.model.bancoId = 0
            this.model.situacionLaboralActividadId = 0
            this.telefonoEditor.numero = 0
            this.model.tipoClienteId = 3 // no cliente
            this.model.sectorOrigenId = 1 // mkt
          }
          
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false


    },
    async setPersonaBusqueda(persona){

      this.selectedPersonaBusqueda = persona
      this.model.personaId = persona.id
      
      //busco los datos que tengo de la persona para rellenar.
      this.loadingProgress = true
        try {
            var result = await http.get('personas/infocrediticia?id=' + this.model.personaId ); 
            console.log(result)  
            this.model.nombre = result.personaDto.apellido + "," + result.personaDto.nombre
            this.model.email = result.personaDto.datosContacto.email

            if(result.personaDto.cuentasBanco.length > 0){
                var codigoBanco = result.personaDto.cuentasBanco[0].cbu.substring(0,3)
                var entidad = this.listBancos.find(x=>x.codigo == codigoBanco)
                if(entidad)
                    this.model.bancoId = entidad.id
            }
            
            this.model.situacionLaboralActividadId = result.personaDto.empleo.situacionLaboralActividadId
            
            var telefonoParticular =  result.personaDto.datosContacto.telefonos.find(x=>x.perteneceA.id == 1)
            if(telefonoParticular)
                this.telefonoEditor.numero =telefonoParticular.telediscado

            if(result.tipoCalificacionId == 2) // renovador
                this.model.tipoClienteId = 5
            else if(result.tipoCalificacionId == 3) // fugado
                this.model.tipoClienteId = 2
            else
                this.model.tipoClienteId = 1 // cliente

            this.model.sectorOrigenId = 2 // at cliente

        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loadingProgress = false
    },
      
    hide(cerrarRelacionados){
        //esto lo hago para que no se buguee cuando lo abro como subtask o task
        if(this.isSubTask)
            this.hideActiveSubTask();
        else
            this.hideActiveTask(cerrarRelacionados);
    }
  }
}
</script>
